<template>
  <div class="limiter">
    <div class="container-login">
      <div class="login-box">
        <form class="login-form validate-form">
          <span class="login-form-title p-b-26">会员登录</span>
          
          <div class="login-input-wrap validate-input">
            <input class="login-input" type="text" v-model="username" required>
            <span class="input-focus" placeholder="账 号"></span>
          </div>

          <div class="login-input-wrap validate-input">
            <input class="login-input" :type="showPass ? 'text' : 'password'" v-model="password" required>
            <span class="input-focus" placeholder="密 码"></span>
            <span class="btn-show-pass" @click="togglePassword">
              <i :class="showPass ? 'gg-eye' : 'gg-eye-close'"></i>
            </span>
          </div>

          <div class="login-input-wrap validate-input" v-if="codeInfo!=2">
            <input class="login-input" type="text" v-model="code" required>
            <span class="input-focus" placeholder="验证码"></span>
            <span class="btn-show-yzm">
              <img class="gg-yzm" :src="code_url" @click="refreshVerifyCode" />
            </span>
          </div>

          <div class="container-login-form-btn">
            <button class="login-form-btn" @click.prevent="loginApp" :disabled="isButtonDisabled">
              {{ buttonText }}
            </button>
        </div>

          <div class="text-center mobile-link">
            <a href="javascript:;" @click="goPage('https://mm.ts608.com/login')" class="mobile-version">
              手机版
            </a>
        </div>

          <div class="text-center p-t-115"></div>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode } from '@/service/user'
import { mapActions } from "vuex";

var nv='';
var fromurl=document.referrer;
if (fromurl.indexOf("mm.ts608.com") > -1)
{
  var nv='1';
}

export default {
  name: "login",
  data() {
    return {
      buttonText: '登录',
      isButtonDisabled: false,
      num: 1,
      username: '',
      password: "",
      code: "",
      ismobile:nv,
      codeInfo: '',
      showPass: false
    };
  },
  computed: {
    code_url() {
      return `/api/ssc_golang/v1/user/captcha?n=${this.num}&random=${new Date().getTime()}`;
    }
  },
  mounted() {
    this.queries = this.$route.query;
    this.getCode();
  },
  watch: {
    code() {
      if(this.code.length>4){
        this.code = this.code.substring(0,4);
      }
    }
  },
  methods: {
    ...mapActions("root", ["login"]),
    ...mapActions("table", {
      getData: "load_d23_data"
    }),
    refreshVerifyCode() {
      this.num++;
    },
    async getCode() {
        this.codeInfo = await getCode();
        if(this.codeInfo==1){
          this.refreshVerifyCode();
        }
    },
    togglePassword() {
      this.showPass = !this.showPass;
    },
    async loginApp() {
      if(this.codeInfo!=2){
        var info = this.$validate.group(
          this.$validate("username", this.username),
          this.$validate("password", this.password),
          this.$validate("code", this.code)
        );
      }else{
        var info = this.$validate.group(
          this.$validate("username", this.username),
          this.$validate("password", this.password)
        );
      }

      if (info) return this.$Message.error(info);
      this.buttonText = '登录中，请稍候';
      this.isButtonDisabled = true;
      const res = await this.login({
        username: this.username,
        password: this.password,
        code: this.code
      });

      this.num++;

      if (res.result !== "ok"){
        if(res.msg=="请您进行密码更换")
        {
          this.password = "";
          this.code = "";
          this.$MessageBox.show('d28', {
            title: '修改密码'
          });
          this.isButtonDisabled = false;
          this.buttonText = '登录';
          return;
        }
        this.isButtonDisabled = false;
        this.buttonText = '登录';
        return this.$Message.error(res.msg);
      }
      this.getData();
      if(res.msg=='3'){
          this.isButtonDisabled = false;
          this.buttonText = '登录';
          this.$Message.error('该帐号已被冻结，请联系您的上级！');
      }
      // this.$router.replace(this.queries.path || '/home/pk10');
      this.buttonText = '登录成功，正在跳转';
      const path = this.queries.path || "";
      if (path != "")
        this.$router.replace("/agreement?path=" + this.queries.path);
      else this.$router.replace("/agreement");
    },
    goPage(url) {
      window.location.href = url;
      window.event.returnValue=false;
    }
  }
};
</script>

<style scoped>
* {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box
}

input {
  outline: none;
    border: none
}

button {
    outline: none !important;
    border: none;
    background: transparent
}

.container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: inherit;
}

.login-box {
    width: 390px;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    overflow: hidden;
    padding: 77px 55px 33px 55px;
    box-shadow: 0 5px 10px 0px rgb(0 0 0 / 10%);
}

.login-form {
    width: 100%
}

.login-form-title {
    display: block;
    font-family: Arial,Helvetica,sans-serif;
    color: #d80606;
    font-size: 38px;
    font-weight: bold;
    text-shadow: 1px 1px #fff;
    text-align: center
}

.validate-input {
    position: relative
}

.login-input-wrap {
    width: 100%;
    position: relative;
    margin-bottom: 37px;
    border-bottom: 2px solid #adadad
}

.login-input {
    font-family: Arial,Helvetica,sans-serif;
    font-size: 15px;
    color: #555555;
    line-height: 1.2;
    display: block;
    width: 100%;
    height: 45px;
    background: transparent;
    padding: 0 5px
}

.input-focus {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none
}

.input-focus::before {
    content: "";
    display: block;
    position: absolute;
    bottom: -2px;
    left: 0;
      width: 0;
    height: 2.5px;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s;
    background: #6a7dfe;
    background: -webkit-linear-gradient(left,#21d4fd,#b721ff);
    background: -o-linear-gradient(left,#21d4fd,#b721ff);
    background: -moz-linear-gradient(left,#21d4fd,#b721ff);
    background: linear-gradient(left,#21d4fd,#b721ff)
}

.input-focus::after {
    font-family: Arial,Helvetica,sans-serif;
    font-size: 14px;
    color: #999999;
    line-height: 1.2;
    content: attr(placeholder);
    display: block;
    width: 100%;
    position: absolute;
    top: 16px;
    left: 0px;
    padding-left: 5px;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s
}

.login-input:focus~.input-focus::before,
.login-input:valid~.input-focus::before {
    width: 100%
}

.login-input:focus~.input-focus::after,
.login-input:valid~.input-focus::after {
    top: -10px
}

.btn-show-yzm {
    font-size: 15px;
    color: #999999;
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    bottom: 5px;
    right: 0;
    padding-right: 5px;
    cursor: pointer;
    transition: all 0.4s
}

.gg-yzm {
    width: 140px;
    height: 40px;
    border: 0;
    position: relative;
}

.btn-show-pass {
    font-size: 15px;
    color: #999999;
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    top: 4px;
    right: 0;
    padding-right: 5px;
    cursor: pointer;
    transition: all 0.4s
}

.gg-eye,.gg-eye-close {
    width: 16px;
    height: 16px;
    border: solid 2px #999999;
    border-radius: 70% 20%;
    position: relative;
    transform: rotate(45deg)
}

.gg-eye::before,.gg-eye-close::before {
    content: '';
        display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    border: solid 2px #999999;
    border-radius: 50%;
    left: 2px;
    top: 2px
}

.gg-eye-close::after {
    content: '';
    position: absolute;
    top: -5px;
    left: 5px;
    width: 1.5px;
    height: 22px;
    background: #999999;
    transform: rotate(80deg)
}

.gg-eye:hover,.gg-eye-close:hover,
.gg-eye-close:hover::before,.gg-eye:hover::before {
    border: solid 2px #6a7dfe
}

.gg-eye-close:hover::after {
    background: #6a7dfe
}

.container-login-form-btn {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.login-form-btn {
    width: 100%;
    height: 44px;
    background: linear-gradient(90deg, #00c6fb 0%, #005bea 100%);
    border: none;
    border-radius: 22px;
        color: #ffffff;
        font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.login-form-btn:hover {
    background: linear-gradient(90deg, #005bea 0%, #00c6fb 100%);
    box-shadow: 0 5px 15px rgba(0, 91, 234, 0.3);
}

.login-form-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
    box-shadow: none;
}

.p-b-26 {
    padding-bottom: 26px
}

.p-t-115 {
    padding-top: 99px
}

.mobile-link {
    margin-top: 15px;
    text-align: right;
    padding-right: 5px;
}

.mobile-version {
    color: #666666;
    font-size: 13px;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;
    padding-right: 15px;
}

.mobile-version::after {
    content: '';
    position: absolute;
    right: 0;
    top: 20%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-top: 1px solid #666666;
    border-right: 1px solid #666666;
    transform: rotate(45deg);
}

.mobile-version:hover {
    color: #03A9F4;
}

.mobile-version:hover::after {
    border-color: #03A9F4;
}

@media screen and (max-width: 900px) {
    .login-box {
        width: 90%;
        padding: 50px 30px 20px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue